import CoachLocation from './CoachLocation'
export default CoachLocation
